import React from 'react'
import { useStyles } from './TopicsStyle'
import greaterThan from '../../../assets/icons/servTopics/greaterthan.svg'
import downArrow from '../../../assets/icons/servTopics/downArrow.svg'
import info from '../../../assets/icons/servTopics/info.svg'
import search from '../../../assets/icons/servTopics/search.svg'
import { Grid, Input } from '@material-ui/core'
import TopicModal from '../../../components/topicsModal/TopicsModal'
export default function Topics() {
    const style = useStyles()
    return (
        <div>
            <div className={style.headingDiv}>
                <div className={style.topicsFont}>
                    Topics
                </div>
                <div className={style.greaterThanImg}><img src={greaterThan} width={7.8} height={13.65} alt="greaterThan" /></div>
                <div className={style.topicsAll}>All</div>
            </div>
            <div className={style.AddtopicsDiv}>
                <div className={style.AddTopicsText}>Add a new Topic</div>
                <div className={style.topicsNameText}>Topic name</div>
                <input placeholder='mytopic' className={style.topicInput} />
                <div className={style.advanceAlign}>
                    <div className={style.advanceAlignArrow}><img src={downArrow} width={12} height={9} alt="downArrow" /></div>
                    <div className={style.advancetxt}>Advanced Configuration</div>
                </div>
                <Grid container>
                    <Grid xl={4} lg={4} mg={4} sm={12} xs={12}>
                        <div className={style.subGridDivs}>
                            <div className={style.advanceGridTxt}>Replication</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} value="3" />
                    </Grid>
                    <Grid xl={4} lg={4} mg={4} sm={12} xs={12}>
                        <div className={style.subGridDivs}>
                            <div className={style.advanceGridTxt}>Partitions</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} value="1" />
                    </Grid>
                    <Grid xl={4} lg={4} mg={4} sm={12} xs={12}>
                        <div className={style.subGridDivs}>
                            <div className={style.advanceGridTxt}>Retention bytes</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} value="-1" />
                    </Grid>
                </Grid>
                <Grid container >
                    <Grid item xl={4} lg={4} mg={4} sm={12} xs={12} >
                        <div className={style.subGridDivs2}>
                            <div className={style.advanceGridTxt}>Retention ms</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} value="5821000685" />
                    </Grid>
                    <Grid item xl={4} lg={4} mg={4} sm={12} xs={12}>
                        <div className={style.subGridDivs2}>
                            <div className={style.advanceGridTxt}>MIn insync replicas</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} value="1" />
                    </Grid>
                    <Grid item xl={4} lg={4} mg={4} sm={12} xs={12}>
                        <div className={style.subGridDivs2}>
                            <div className={style.advanceGridTxt}>Cleanup policy</div>
                            <img src={info} height={15} width={15} alt='info' />
                        </div>
                        <input type="number" className={style.numberInput} placeholder="Default" />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12} ><button className={style.cleanButton}>Clean values</button></Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}><div className={style.configAlign}><TopicModal /></div></Grid>
                </Grid>
            </div>
            <Grid container>
                <Grid xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className={style.subSearchBarDiv}>
                        <Grid container>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                                <div className={style.topicListtxt}>Topic List</div>
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                                <div className={style.searchtxt}>Search help</div>
                            </Grid>
                        </Grid>
                        <div >
                            <div className={style.searchPosition}><img src={search} alt="search" /></div>
                            <input type="text" className={style.searchinput} placeholder="Search by Topic List" />
                        </div>
                        <div className={style.topicsNotFound}>
                            No topic found
                        </div>
                    </div>

                </Grid>
                <Grid xl={6} lg={6} md={6} sm={12} xs={12}>
                   

                </Grid>
                
            </Grid>
        </div>
    )
}
